<template>
    <!-- The solution is visible -->
    <template v-if="show">
        <slot/>
    </template>

    <!-- The solution is hidden -->
    <template v-else>
        <a
            href="#"
            @click.prevent="showSolution()"
        >Показать ответ</a>
    </template>
</template>

<script>
export default {
    name: 'HideSolution',
    data() {
        return {
            show: false,
        }
    },
    methods: {
        // Show the solution
        showSolution() {
            return this.show = true
        }
    },
}
</script>

<style scoped lang="scss">
a {
    line-height: 1.3rem;
}
</style>
